module.exports = __webpack_public_path__ + "img/30.57603570.webp";